import { formatTime, getRemainingTime } from '../utils/gatingHelper';
import { getLocalStorage } from '../utils/Utils';

export const createGatingTimer = (
  videoPlayer: any,
  assetId: string,
  limitSeconds: number,
  onSubscribe: () => void,
  gatingType: string = 'subscription',
  isLive: boolean = true
) => {
  if (document.querySelector('.freeMinutesInfoContainerLiveTv')) return;

  const { messages = {} } = (window as any)?.translationsAndConfigs || {};

  const freeMinutesInfoContainer = document.createElement('div');
  freeMinutesInfoContainer.className = 'freeMinutesInfoContainerLiveTv';

  const gatingTimerWrapper = document.createElement('div');
  gatingTimerWrapper.className = 'gatingTimerWrapper';

  const freeMinutesInfoText = document.createElement('div');
  freeMinutesInfoText.className = 'freeMinutesInfoText';
  freeMinutesInfoText.innerHTML = messages?.FreeWatchEndsIn_Text || 'Free watch ends in ';

  const freeMinutesTimer = document.createElement('span');
  freeMinutesTimer.className = 'freeMinutesTimer';
  freeMinutesTimer.id = 'freeMinutesTimer';

  const remainingTime = isLive
    ? getRemainingTime(assetId, limitSeconds)
    : Math.max(0, limitSeconds - Math.floor(videoPlayer?.currentTime?.() || 0));

  freeMinutesTimer.innerHTML = formatTime(remainingTime);

  freeMinutesInfoText.appendChild(freeMinutesTimer);
  gatingTimerWrapper.appendChild(freeMinutesInfoText);

  const userType = getLocalStorage('userType') || 'guest';
  let buyCtaText = userType === 'premium' ? 'Upgrade' : 'Buy Premium';
  if (gatingType === 'login') {
    buyCtaText = 'Login';
  }

  // Add "Buy Plan" button (using user's buyPlanBtn class and icon span)
  const buyPlanBtn = document.createElement('div');
  buyPlanBtn.className = 'buyPlanBtn';
  buyPlanBtn.innerHTML =
    gatingType === 'login'
      ? buyCtaText
      : `<span class="icon-crown"></span> ${buyCtaText}`;
  buyPlanBtn.onclick = (e) => {
    e.stopPropagation();
    onSubscribe();
  };
  gatingTimerWrapper.appendChild(buyPlanBtn);

  freeMinutesInfoContainer.appendChild(gatingTimerWrapper);

  const videoEL = videoPlayer && videoPlayer.el();
  if (videoEL) {
    videoEL.appendChild(freeMinutesInfoContainer);
  }
};

export const updateGatingTimerUI = (
  assetId: string,
  limitSeconds: number,
  isLive: boolean = true,
  currentTime: number = 0
) => {
  const timerElement = document.getElementById('freeMinutesTimer');
  if (timerElement) {
    const remainingTime = isLive
      ? getRemainingTime(assetId, limitSeconds)
      : Math.max(0, limitSeconds - Math.floor(currentTime));
    timerElement.innerHTML = formatTime(remainingTime);
  }
};

export const removeGatingTimer = () => {
  const container = document.querySelector('.freeMinutesInfoContainerLiveTv');
  if (container && container.parentNode) {
    container.parentNode.removeChild(container);
  }
};

export const showGatingPopup = (
  videoPlayer: any,
  onSubscribe: () => void,
  gatingType: string = 'subscription'
) => {
  if (document.querySelector('.freeMinutesEndedPopup')) return;
  const { messages = {} } = (window as any)?.translationsAndConfigs || {};

  videoPlayer.pause();

  const popupOverlay = document.createElement('div');
  popupOverlay.className = 'freeMinutesEndedPopup';

  const popupContent = document.createElement('div');
  popupContent.className = 'popupContent';

  const titleText =
    gatingType === 'login'
      ? messages?.FreeWatchEnded_Text_Register
      : messages?.FreeWatchEnded_Text;
  const title = document.createElement('h2');
  title.innerHTML = titleText || 'Your free watch has ended.';

  const message = document.createElement('p');
  const descriptionText =
    gatingType === 'login'
      ? messages?.Player_Msg_LoginToView
      : messages?.BuyPremium_Text;
  message.innerHTML = descriptionText || 'Buy Plan to continue watching.';

  const subscribeBtn = document.createElement('button');
  subscribeBtn.className = 'subscribeBtn';

  const userType = getLocalStorage('userType') || 'guest';
  let buyCtaText = userType === 'premium' ? 'Upgrade' : messages?.playerGatingSubscriptionCTA_text || 'Buy Premium';
  if (gatingType === 'login') {
    buyCtaText = messages?.playerGatingLoginCTA_text || 'Login';
  }

  // User added icon-crown in span for the popup button too in their SCSS
  subscribeBtn.innerHTML =
    gatingType === 'login'
      ? buyCtaText
      : `<span class="icon-crown"></span> ${buyCtaText}`;
  subscribeBtn.onclick = onSubscribe;

  popupContent.appendChild(title);
  popupContent.appendChild(message);
  popupContent.appendChild(subscribeBtn);
  popupOverlay.appendChild(popupContent);

  const videoEL = videoPlayer && videoPlayer.el();
  if (videoEL) {
    videoEL.appendChild(popupOverlay);
  }
};
